import { Question } from "@/api/minutes-api.ts";

export default function QuestionFormData(question: Question) {
  const d = new FormData();
  d.append("id", String(question.id));
  d.append("title", question.title);
  question.answers.forEach((a, i) => {
    d.append(`answers[${i}][id]`, String(a.id));
    d.append(`answers[${i}][type]`, a.type);
    d.append(`answers[${i}][question]`, a.question);
    a.options.forEach((o, x) => {
      d.append(`answers[${i}][options][${x}][id]`, String(o.id));
      d.append(`answers[${i}][options][${x}][text]`, o.text);
    });
  });
  return d;
}

export function newQuestionFormData(question: Question) {
  const d = new FormData();
  d.append("id", "");
  d.append("title", question.title);
  question.answers.forEach((a, i) => {
    d.append(`answers[${i}][id]`, "");
    d.append(`answers[${i}][type]`, a.type);
    d.append(`answers[${i}][question]`, a.question);
    a.options.forEach((o, x) => {
      d.append(`answers[${i}][options][${x}][id]`, "");
      d.append(`answers[${i}][options][${x}][text]`, o.text);
    });
  });
  return d;
}
